export const NO_INTERNET_MESSAGE = 'No Internet Connection';

export const isBrowserOffline = () => !navigator.onLine;

export const isNetworkFetchError = (error) => {
  if (!navigator.onLine) return true;
  if (!error) return false;

  const message = String(error.message || error).toLowerCase();

  return (
    message.includes('the internet connection appears to be offline') ||
    message.includes('err_internet_disconnected') ||
    message.includes('err_network_changed')
  );
};

export const normalizeNetworkError = (
  error,
  fallback = 'Something went wrong',
) => {
  if (!error) return fallback;

  if (typeof error === 'string') {
    if (!navigator.onLine) return NO_INTERNET_MESSAGE;
    return error;
  }

  if (!navigator.onLine || isNetworkFetchError(error)) {
    return NO_INTERNET_MESSAGE;
  }

  return error?.message || fallback;
};

export const checkInternetConnection = async () => navigator.onLine;

export const assertInternetConnection = async () => {
  if (!navigator.onLine) {
    throw new Error(NO_INTERNET_MESSAGE);
  }
  return true;
};

export const installFetchNetworkInterceptor = () => {
  if (window.__eopsFetchInterceptorInstalled) return;
  window.__eopsFetchInterceptorInstalled = true;

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    try {
      return await nativeFetch(...args);
    } catch (error) {
      if (!navigator.onLine) {
        throw new Error(NO_INTERNET_MESSAGE);
      }
      throw error;
    }
  };
};
